module.exports = __webpack_public_path__ + "static/media/gif-icon.668e1b16.svg";